export default __webpack_public_path__ + "static/media/ai2.b5a412b4.png";